/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import QueueScheduleRowComponent from 'app/components/Queue/QueueScheduleRowComponent.jsx';
import QueueScheduleRowMobileComponent from 'app/components/Queue/QueueScheduleRowMobileComponent.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import * as _ from 'underscore';
import FilterModule from 'app/mixins/FilterModule.js';
import EmptyState from 'app/components/common/EmptyState.jsx';
import QueueScheduleRowEditor from 'app/components/Queue/QueueScheduleRowEditor.jsx';
import QueueScheduleRowEditorMobile from 'app/components/Queue/QueueScheduleRowEditorMobile.jsx';
import Utilities from 'app/utility/Utilities.js';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import { Breakpoint } from 'react-socks';

class QueueScheduleComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editingSchedule: 0,
            error: ''
        };

        this._onCheckChange = this._onCheckChange.bind(this);
        this._changeTimeSlot = this._changeTimeSlot.bind(this);
        this.toggleScheduleDay = this.toggleScheduleDay.bind(this);
        this.isDayInSchedules = this.isDayInSchedules.bind(this);
        this.toggleRow = this.toggleRow.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            errors = null,
            error = '';

        errors = props.getApiErrors(['SOCIAL_UPDATE']);

        if (errors.length) {
            for (let i = 0; i < errors.length; ++i) {
                if (errors[i].errors.validation !== undefined && errors[i].errors.validation.sched !== undefined) {
                    for (let key in errors[i].errors.validation.sched) {
                        if (errors[i].errors.validation.sched[key].s_days !== undefined) {
                            error = errors[i].errors.validation.sched[key].s_days;
                            if (error.match("At least one day")) {
                                error = "A schedule must have at least one active time. Toggling the day or the time would result in a schedule with no active times. If this is what you'd like, just use the 'x' to delete the schedule.";
                            }
                            break;
                        } else if (error.match("Invalid Tag ID")) {
                            error = "An invalid category id was selected";
                        } else {
                            error = "That time conflicts with another schedule";
                            break;
                        }
                    }
                } else if (errors[i].errors.validation !== undefined && errors[i].errors.validation.params !== undefined) {
                    let errorString = "";
                    for (let key in errors[i].errors.validation.params) {
                        errorString += key + ": " + errors[i].errors.validation.params[key] + " ";
                    }
                    error = "There was an error updating your schedule (" + errorString + ")";
                }
            }
            if (error) {
                nextState.error = error;
            }
        } else if (errors.length === 0 && state.error !== '') {
            nextState.error = '';
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.error === '' && (_.isString(this.state.error) && this.state.error !== '')) {
            if (!this.props.isModalVisible()) {
                let action = () => {
                        this.props.closeAllModals();
                        this.setState({
                            error: ''
                        });
                    },
                    confirmModal = (
                        <ConfirmModal
                            modalCopy={this.state.error}
                            confirmAction={action}
                            closeAction={action}
                            confirmLabel={"OK"}
                            showCancel={false}/>
                    );

                this.props.addModal(confirmModal);
            }
        }

    }

    _onCheckChange(e) {

        let day = parseInt(e.currentTarget.dataset.daybit, 10),
            id = parseInt(e.currentTarget.dataset.sid, 10),
            removeSchedule = e.currentTarget.dataset.delete,
            social = Utilities.deepClone(this.props.social),
            schedule = null,
            schedules = null,
            days = 0;

        const hasZeroSchedules = (schedules) => {
            if (schedules.length === 0) {
                this.props.addModal(
                    <ConfirmModal
                        showCancel={false}
                        confirmAction={() => {
                            this.props.closeAllModals();
                        }}
                        closeAction={() => {
                            this.props.closeAllModals();
                        }}
                        modalCopy="You must keep at least one scheduled time for a social"
                        confirmLabel="OK"/>
                );
                return true;
            }
            return false;
        }

        if (removeSchedule === "true") {
            schedules = _.reject(social.sched, function(obj){
                return obj.s_id == id;
            }, this);

            if(hasZeroSchedules(schedules)) {
                return;
            }
            social.sched = schedules;
        } else {
            schedule = _.findWhere(social.sched, {'s_id': id});
            days = parseInt(schedule.s_days, 10);

            if (days & day) {
                days = days ^ day;
            } else {
                days = days | day;
            }

            // someone toggled off the last day in a row
            // delete the time
            if (days === 0) {
                schedules = _.reject(social.sched, function(obj){
                    return obj.s_id == id;
                }, this);

                if (hasZeroSchedules(schedules)) {
                    return;
                }
                social.sched = schedules;
            } else {
                schedule.s_days = days;
            }

        }

        this.props.updateSchedules(social);

    }

    _changeTimeSlot(id, newTime, category, days) {

        let social = Utilities.deepClone(this.props.social);

        for (let i = 0; i < social.sched.length; i++) {
            if (social.sched[i].s_id === id) {
                social.sched[i].s_startTime = newTime;
                social.sched[i].s_tagID = category || 0;
                if (days) {
                    social.sched[i].s_days = days;
                }
                break;
            }
        }

        this.props.updateSocial(social);

    }

    toggleScheduleDay(e) {
        let dayBit = parseInt(e.currentTarget.dataset.daybit, 10),
            active = e.currentTarget.dataset.togglestate,
            social = Utilities.deepClone(this.props.social),
            days = 0;

        for (let i = 0; i < social.sched.length; i++) {
            days = parseInt(social.sched[i].s_days);
            if (active === 'true') {
                if (days & dayBit) {
                    social.sched[i].s_days = days ^ dayBit;
                }
            } else {
                if (!(days & dayBit)) {
                    social.sched[i].s_days = days | dayBit;
                }
            }
        }

        this.props.updateSchedules(social);

    }

    isDayInSchedules(day) {

        if (this.props.social.sched !== undefined && this.props.social.sched.length) {
            for (let i = 0; i < this.props.social.sched.length; ++i) {
                if (parseInt(day, 10) & parseInt(this.props.social.sched[i].s_days, 10)) {
                    return true;
                }
            }
        }

        return false;
    }

    toggleRow(e) {
        let editingSchedule = this.state.editingSchedule,
            error = this.state.error;

        // clear out errors on any row state change
        // -- if the user tries to add a new time that's in conflict, but doesn't close the tool
        // the error can stick to the rows
        this.props.deleteApiError(['SOCIAL_UPDATE']);

        if (e.currentTarget.dataset.scheduleid) {
            if (editingSchedule === parseInt(e.currentTarget.dataset.scheduleid, 10)) {
                editingSchedule = 0;
                error = null;
            } else {
                editingSchedule = parseInt(e.currentTarget.dataset.scheduleid, 10);
            }

            this.setState({
                editingSchedule: editingSchedule,
                error: error
            });
        }
    }

    render() {

        let constants = this.props.app.config.constants,
            dayInfo = [
                {'label': 'Sun', 'value': constants.FS_SUNDAY},
                {'label': 'Mon', 'value': constants.FS_MONDAY},
                {'label': 'Tue', 'value': constants.FS_TUESDAY},
                {'label': 'Wed', 'value': constants.FS_WEDNESDAY},
                {'label': 'Thu', 'value': constants.FS_THURSDAY},
                {'label': 'Fri', 'value': constants.FS_FRIDAY},
                {'label': 'Sat', 'value': constants.FS_SATURDAY},
            ],
            schedules = this.props.social.hasOwnProperty('sched')
            ? this.props.social.sched
            : [],
            clickHandler = this._onCheckChange,
            changeHandler = this._changeTimeSlot,
            toggleHandler = this.toggleScheduleDay;

        schedules = _.sortBy(schedules, 's_startTime');

        if (this.props.category !== null) {
            if (parseInt(this.props.category, 10) !== -1) {
                schedules = FilterModule(schedules, 's_tagID', this.props.category.toString(), true);
            }
        }

        if (!_.isEmpty(this.props.social) && schedules.length === 0) {
            let message = (
                <span>
                    The selected social has no scheduled times to post. Add one by clicking 'Add New Time' above.
                </span>
            );
            return (
                <EmptyState message={message}/>
            );
        }

        return (
            <div>
                <Breakpoint desktop only>
                    <table className="component-table queue-component-table">
                        <colgroup>
                            {dayInfo.map((day, i) => {
                                let className = (this.isDayInSchedules(day.value)) ? 'column-active' : 'column-active';

                                return (
                                    <col key={'QueueScheduleColumn' + i} className={className}/>
                                );

                            })}
                            <col className="category-hint-spacer"></col>
                        </colgroup>
                        <thead>
                            <tr>
                                <td></td>
                                {dayInfo.map((day, i) => {
                                    return (
                                        <td key={'QueueScheduleDayName' + i}>
                                            {day.label}
                                        </td>
                                    );
                                })}
                                <td></td>
                                <td className="category-hint-spacer"></td>
                            </tr>
                            <tr>
                                <th></th>
                                {dayInfo.map((day, i) => {
                                    let active = (this.isDayInSchedules(day.value)) ? true : false;

                                    return (
                                        <th key={'QueueScheduleDayToggle' + i}>
                                            <Toggle
                                                active={active}
                                                noLabel={true}
                                                callback={toggleHandler}
                                                data-daybit={day.value} />
                                        </th>
                                    );
                                })}
                                <th></th>
                                <th className="category-hint-spacer"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {schedules.map((schedule, i) => {
                                if (schedule.s_id == this.state.editingSchedule) {
                                    return [
                                            <QueueScheduleRowComponent
                                                {...this.props}
                                                key={'QueueScheduleRowComponent' + i}
                                                schedule={schedule}
                                                days={dayInfo}
                                                clickHandler={clickHandler}
                                                toggleHandler={this.toggleRow}
                                                editingSchedule={this.state.editingSchedule} />,
                                            <QueueScheduleRowEditor
                                                {...this.props}
                                                key={'QueueScheduleRowEditor' + i}
                                                changeHandler={changeHandler}
                                                schedule={schedule}
                                                error={this.state.error} />
                                        ];
                                }
                                return (
                                    <QueueScheduleRowComponent
                                        {...this.props}
                                        key={'QueueScheduleRowComponent' + i}
                                        schedule={schedule}
                                        days={dayInfo}
                                        clickHandler={clickHandler}
                                        toggleHandler={this.toggleRow}/>
                                );
                            })}
                        </tbody>
                    </table>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="mobile-schedules">
                        {schedules.map((schedule, i) => {
                            if (schedule.s_id == this.state.editingSchedule) {
                                return [
                                        <QueueScheduleRowMobileComponent
                                            {...this.props}
                                            key={'QueueScheduleRowComponent' + i}
                                            schedule={schedule}
                                            editingSchedule={this.state.editingSchedule} />,
                                        <QueueScheduleRowEditorMobile
                                            {...this.props}
                                            key={'QueueScheduleRowEditor' + i}
                                            days={dayInfo}
                                            clickHandler={clickHandler}
                                            isDayInSchedules={this.isDayInSchedules}
                                            changeHandler={changeHandler}
                                            schedule={schedule}
                                            error={this.state.error} />
                                    ];
                            }
                            return (
                                <QueueScheduleRowMobileComponent
                                    {...this.props}
                                    key={'QueueScheduleRowComponent' + i}
                                    schedule={schedule}
                                    clickHandler={clickHandler}
                                    toggleHandler={this.toggleRow}/>
                            );
                        })}
                    </div>
                </Breakpoint>
            </div>
        );

    }

};

QueueScheduleComponent.displayName = "QueueScheduleComponent";

QueueScheduleComponent.propTypes = {
    social: PropTypes.object
};

QueueScheduleComponent.defaultProps = {
    social: {}
};

export default QueueScheduleComponent;
